import React from "react"

const about = [
  { num: 8, title: "Years Experience" },
  { num: 72, title: "Projects Completed" },
  { num: 130, title: "GB of Photoshoots" },
]

const Experience = () => {
  return (
    <div className="bg-[url(images/background.webp)] w-full bg-no-repeat">
      <div className="flex flex-wrap justify-around w-full pt-7 text-white md:pt-[87px]">
        {about.map(({ num, title }) => (
          <div
            className="flex flex-col mb-11 w-1/3 md:mb-14"
            key={`${num}_${title}`}
          >
            <div className="mb-2 flex self-center md:mb-5">
              <span className="playfair font-black text-5xl font-playfair text-center md:text-[70px]">
                {num}
              </span>
            </div>
            <hr className="bg-white m-0 w-[81.5px] self-center" />
            <p className="w-[86%] m-0 mt-3 font-ubuntu font-medium text-base text-center self-center md:text-[21px] md:mt-6 md:w-1/2 lg:w-[38%] xl:w-[37%]">
              {title}
            </p>
          </div>
        ))}

        <span className="w-[99%] font-ubuntu font-light text-[16px] leading-[18px] mb-8 mx-3 md:mb-[100px] md:mx-0">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum. Sed ut
          perspiciatis unde omnis iste natus error sit voluptatem accusantium
          doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo
          inventore veritatis et quasi architecto beatae vitae dicta sunt
          explicabo.
        </span>
      </div>
    </div>
  )
}

export default Experience
